export enum ProductTypeEnum {
  Serialized = 1,
  NonSerialized = 2,
  Consumable = 3
}
